<template>
  <b-sidebar
    id="sidebar-axis-body-cam-device"
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    no-close-on-backdrop
    right
    @shown="loadData"
    @hidden="resetForm"
    @change="(val) => $emit('update:is-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0 text-capitalize">
          {{ $t("actions.edit") }} {{ itemEdit.name || itemEdit.serial_number }}
        </h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
          <!-- Device Tag -->
          <validation-provider #default="validationContext" name="DeviceTag">
            <b-form-group
              class="text-capitalize"
              :label="$t('axis_body_cam.devices.device_tag')"
              label-for="id_device_tag"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.id_device_tag"
                :options="deviceTagOptions"
                :reduce="(val) => val.value"
                :clearable="true"
                input-id="id_device_tag"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Reseller -->
          <validation-provider #default="validationContext" name="Reseller">
            <b-form-group
              class="text-capitalize"
              :label="$t('axis_body_cam.devices.reseller')"
              label-for="id_omniview_reseller"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.id_omniview_reseller"
                :options="resellerOptions"
                :reduce="(val) => val.value"
                :clearable="true"
                input-id="id_omniview_reseller"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button variant="primary" class="mr-2" type="submit">
              {{ $t("actions.accept") }}
            </b-button>
            <b-button type="button" variant="outline-secondary" @click="hide">
              {{ $t("actions.cancel") }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar, BForm, BFormGroup, BFormInvalidFeedback, BButton } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import formValidation from "@core/comp-functions/forms/form-validation";
import store from "@/store";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  model: {
    prop: "isSidebarActive",
    event: "update:is-sidebar-active",
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    itemEdit: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    deviceTagOptions: {
      type: Array,
      required: true,
    },
    resellerOptions: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const toast = useToast();

    const blankData = {
      id_device_tag: null,
      id_omniview_reseller: null,
    };

    const itemData = ref(JSON.parse(JSON.stringify(blankData)));

    const resetData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankData));
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetData);

    const loadData = () => {
      itemData.value.id_device_tag = props.itemEdit.id_device_tag ?? null;
      itemData.value.id_omniview_reseller = props.itemEdit.id_omniview_reseller ?? null;
    };

    const onSubmit = () => {
      const params = {
        id_device_tag: itemData.value.id_device_tag,
        id_omniview_reseller: itemData.value.id_omniview_reseller,
      };

      store
        .dispatch("axis_body_cam_devices/edit", { id: props.itemEdit.id, params })
        .then((response) => {
          if (response.success) {
            toast({
              component: ToastificationContent,
              props: { title: response.message, icon: "CheckIcon", variant: "success" },
            });
            emit("refetch-data");
            emit("update:is-sidebar-active", false);
          } else {
            toast({
              component: ToastificationContent,
              props: { title: response.message, icon: "AlertTriangleIcon", variant: "danger" },
            });
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response?.data?.message || "Error",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    return {
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      loadData,
      onSubmit,
    };
  },
};
</script>
